module.exports = __webpack_public_path__ + "img/about-parallax-background.1d5b2476.jpg";